/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDecimalSplit = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M14 22h-2v-2h2zm4.5-9a3.5 3.5 0 0 1 3.5 3.5v2a3.5 3.5 0 1 1-7 0v-2a3.5 3.5 0 0 1 3.5-3.5zm0 2a1.5 1.5 0 0 0-1.5 1.5v2a1.5 1.5 0 0 0 3 0v-2a1.5 1.5 0 0 0-1.5-1.5zm-7.062 2-3.847 3.719L6.2 19.28 7.526 18H2v-2h5.526l-1.325-1.281 1.39-1.438zM6 11H4V9h2zm4.5-9A3.5 3.5 0 0 1 14 5.5v2a3.5 3.5 0 1 1-7 0v-2A3.5 3.5 0 0 1 10.5 2zm0 2A1.5 1.5 0 0 0 9 5.5v2a1.5 1.5 0 1 0 3 0v-2A1.5 1.5 0 0 0 10.5 4zm8-2A3.5 3.5 0 0 1 22 5.5v2a3.5 3.5 0 1 1-7 0v-2A3.5 3.5 0 0 1 18.5 2zm0 2A1.5 1.5 0 0 0 17 5.5v2a1.5 1.5 0 0 0 3 0v-2A1.5 1.5 0 0 0 18.5 4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDecimalSplit as DecimalSplit };
